const regions = [
  { _id: 'www', name: 'North America (NA)' },
  // { _id: 'eu.account', name: 'Europe (EU)' },
  // { _id: 'apac.account', name: 'Far East (FE)' },
];

export default regions;
